/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
  Container,
  Segment,
  Icon,
  Table,
} from "semantic-ui-react";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import MandatoryMark from "../common/mandatorymark";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import cogoToast from "cogo-toast";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";

const CancelOrders = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  movementType,
  ...props
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  let [isFormSubmitting, setIsFormSubmitting] = useState(false);

  useEffect(() => {

  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  let cancelBookingRequest = () => {
    let tempOrderList = props.orders;
    let tempList = [];
    for (let i = 0; i < tempOrderList.length; i++) {
      let temp = tempOrderList[i].booking_id;
      tempList.push(temp)
    }

    let rejection_reason = document.getElementById("rejection_reason").value;
    allAxiosCommonTA({
      url: "/bookings/reject",
      method: "post",
      Items: { booking_ids: tempList, rejection_reason: rejection_reason },
    })
      .then((response) => {
        setIsFormSubmitting(false);
        for (let index = 0; index < response.data.message.length; index++) {
          const element = response.data.message[index].message;
          cogoToast.info(element, { hideAfter: 12.5 });
        }
        setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 100);
      })
      .catch((err) => {
        console.log(err)
        if (err?.message)
          cogoToast.info("Remark should not be empty", { hideAfter: 7.5 });//(err.message, { hideAfter: 7.5 });
        console.log('----------cancle order error msg--------');
        console.log(err.message[0]);
        setIsFormSubmitting(false);
      });
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="small"
        style={{
          /* padding: '50px 0 50px 0' */
        }}
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            color="green"
            className="m-2 w3-hover-green"
            circular
          >
            {"Cancel Order"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{"Cancel Order"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <label className="required-form-element">Remarks</label><br /><br />
          <textarea rows="4" cols="50" id="rejection_reason" />
          <div className="display-flex-center-justify-center" style={{
            padding: '10px 0 10px 0'
          }}>
            <button
              className="submit-generate-order w3-button w3-blue w3-hover-blue w3-round w3-small"
              onClick={cancelBookingRequest}
              disabled={isFormSubmitting}
            >
              {isFormSubmitting ? <Icon name="spinner" /> : <span>Submit</span>}
            </button>
          </div>
        </Modal.Content>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
// TODO: validation

export default CancelOrders;
